import React, { useState, useEffect } from 'react';
import { injectIntl } from 'react-intl';
import { MetaInput } from '.';
import { Button } from 'react-bootstrap';
import classNames from 'classnames';

const RepeatingGroupInput = ({
  metaTags,
  fileIndex,
  tagIndex,
  handleInputChange,
  parentUserInput,
  setShowModal,
  id,
  intl,
}) => {
  const [repeatingInputGroups, setRepeatingInputGroups] = useState(
    Array.isArray(parentUserInput) ? parentUserInput : []
  );
  const [baseInput, setBaseInput] = useState([]);
  const [isChangesMade, setIsChangesMade] = useState(false);
  useEffect(() => {
    if (metaTags.length > baseInput.length) {
      updateBaseInput();
    }
  }, []);

  const getMaxP = () => {
    let maxP = 0;

    for (let i = 0; i < repeatingInputGroups.length; i++) {
      if (parseInt(repeatingInputGroups[i][0].position) > maxP)
        maxP = parseInt(repeatingInputGroups[i][0].position);
    }
    return maxP;
  };
  const updateBaseInput = () => {
    let maxP = getMaxP();
    setBaseInput((prevBaseInput) => {
      let differenceInLength = metaTags.length - prevBaseInput.length;
      let temp = [...prevBaseInput]; // Create a copy of the array

      for (let i = 0; i < differenceInLength; i++) {
        temp.push({
          tagName: metaTags[i].meta.name,
          tagId: metaTags[i].meta.id,
          position: maxP + 1,
          userInput: '',
        });
      }
      return temp;
    });
  };
  const handleEntryToAdd = (_, tagIndex, newValue) => {
    setBaseInput((prevBaseInputs) => {
      const temp = [...prevBaseInputs];
      temp[tagIndex] = { ...temp[tagIndex], userInput: newValue };
      return temp;
    });
  };

  const handleReatingInputGroupChange = (groupIndex, tagIndex, newValue) => {
    setIsChangesMade(true);
    setRepeatingInputGroups((prevGroupData) => {
      const newGroupData = [...prevGroupData];
      newGroupData[groupIndex] = [...newGroupData[groupIndex]];
      newGroupData[groupIndex][tagIndex] = {
        ...newGroupData[groupIndex][tagIndex],
        userInput: newValue,
      };
      return newGroupData;
    });
  };

  const addRepetingInputGroup = () => {
    setIsChangesMade(true);
    setRepeatingInputGroups((prevInputGroups) => [
      ...prevInputGroups,
      baseInput,
    ]);
  };

  useEffect(() => {
    setBaseInput((prevBaseInput) => {
      let tempBaseInput = [...prevBaseInput];
      let maxP = getMaxP();
      for (let i = 0; i < tempBaseInput.length; i++) {
        tempBaseInput[i] = {
          tagName: metaTags[i].meta.name,
          tagId: metaTags[i].meta.id,
          position: maxP + 1,
          userInput: tempBaseInput[i]?.userInput,
        };
      }
      return tempBaseInput;
    });
  }, [repeatingInputGroups]);

  const removeRepeatingInputAt = (repeatingInputIndex) => {
    setIsChangesMade(true);
    setRepeatingInputGroups((prevRepeatingInputs) => {
      const temp = [...prevRepeatingInputs]; // Create a copy of the array
      if (repeatingInputIndex < 0 || repeatingInputIndex >= temp.length) {
        return temp;
      }
      temp.splice(repeatingInputIndex, 1);
      return temp;
    });
  };

  const saveChanges = () => {
    handleInputChange(fileIndex, tagIndex, repeatingInputGroups);
    setShowModal(false);
  };

  const discardChanges = () => {
    setShowModal(false);
  };
  return (
    <div className="photo-uploader__image-list-Modal-container">
      <div className="photo-uploader__image-list-Modal-custom-body">
        <div>
          <h5>{intl.formatMessage({ id: 'metaInput.newEntry' })}</h5>
          <div
            className={classNames(
              'photo-uploader-horizontal-line',
              'photo-uploader-margin-bottom'
            )}
          />
          {metaTags.map((tag, tagIndex) => {
            return (
              <div key={id + '_' + tagIndex}>
                <h6>{tag.meta.name}</h6>
                <div className="photo-uploader__image-list-Modal-input">
                <MetaInput
                  fileIndex={fileIndex}
                  tagIndex={tagIndex}
                  handleInputChange={handleEntryToAdd}
                  userInput={
                    baseInput[tagIndex]?.userInput
                      ? baseInput[tagIndex]?.userInput
                      : ''
                  }
                  metaTag={tag}
                  isRGroupChild={true}
                />
                </div>
                <div className="photo-uploader-margin-bottom" />
              </div>
            );
          })}
          <Button
            onClick={addRepetingInputGroup}
            className="photo-uploader-margin-top photo-uploader-margin-bottom"
          >
            {intl.formatMessage({ id: 'general.add' })}
          </Button>
        </div>
        <br />
        {/* Existing Values */}
        {repeatingInputGroups.length > 0 && (
          <div>
            <h5>{intl.formatMessage({ id: 'metaInput.existingEntries' })}</h5>
            <div
              className={classNames(
                'photo-uploader-horizontal-line',
                'photo-uploader-margin-bottom'
              )}
            />
            {repeatingInputGroups.map((group, groupIndex) => {
              return (
                <div key={id + '_group_' + groupIndex}>
                  <h6 className="photo-uploader__image-list-Modal-entry-number">
                    {intl.formatMessage(
                      { id: 'metaInput.entryNum' },
                      { number: groupIndex + 1 }
                    )}
                  </h6>
                  {group.map((tag, tagIndex) => {
                    return (
                      <div key={id + '_group_tag_' + tagIndex}>
                        <h6>{metaTags[tagIndex].meta.name}</h6>
                        <div className="photo-uploader__image-list-Modal-input">
                        <MetaInput
                          fileIndex={groupIndex}
                          tagIndex={tagIndex}
                          handleInputChange={handleReatingInputGroupChange}
                          userInput={
                            repeatingInputGroups[groupIndex][tagIndex].userInput
                          }
                          metaTag={metaTags[tagIndex]}
                          isRGroupChild={true}
                        />
                        </div>
                        <div className=" photo-uploader-margin-bottom" />
                      </div>
                    );
                  })}
                  <Button
                    onClick={() => {
                      removeRepeatingInputAt(groupIndex);
                    }}
                    className="photo-uploader-margin-top photo-uploader-margin-bottom"
                  >
                    {intl.formatMessage({ id: 'general.remove' })}
                  </Button>
                </div>
              );
            })}
          </div>
        )}
      </div>
      <div className="photo-uploader__image-list-Modal-custom-footer">
        <div
          className={classNames(
            'photo-uploader-horizontal-line',
            'photo-uploader-margin-bottom'
          )}
        />
        <div>
          {isChangesMade && (
            <Button onClick={() => discardChanges()} className={'mg-right-5'}>
              {intl.formatMessage({
                id: 'general.cancel',
              })}
            </Button>
          )}
          <Button
            onClick={() => (isChangesMade ? saveChanges() : discardChanges())}
          >
            {intl.formatMessage({
              id: isChangesMade ? 'general.save' : 'general.close',
            })}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default injectIntl(RepeatingGroupInput);
